import Aerofix from '@assets/thumbnails/aeroFIX.jpg'
import Aerofix2 from '@assets/thumbnails/AeroFIX-2.0.jpg'
import AerofixRWF from '@assets/thumbnails/aeroFIX_RWF.jpg'
import AerofixRWF2 from '@assets/thumbnails/AeroFIX_RWF-2.0.jpg'
import MaxSpace from '@assets/thumbnails/ms.jpg'
import MaxSpaceCS from '@assets/thumbnails/mscs+.jpg'
import Cosmo from '@assets/thumbnails/cosmo.jpg'
import PixelPro from '@assets/thumbnails/pixel-pro.jpg'
import Sky from '@assets/thumbnails/sky.jpg'
import Sky2 from '@assets/thumbnails/sky-2.0.jpg'
import Pixel from '@assets/thumbnails/pixel.jpg'
import Kite from '@assets/thumbnails/kite.jpg'
import Iq from '@assets/thumbnails/iq.jpg'
import Dock from '@assets/thumbnails/dock.jpg'
import Mata from '@assets/thumbnails/mata.jpg'
import Mirror from '@assets/thumbnails/lusterko.jpg'
import Organiser from '@assets/thumbnails/organiser.jpg'
import Insert from '@assets/thumbnails/wkładka.jpg'
import SleepBag from '@assets/thumbnails/śpiworek.jpg'
import Ponczo from '@assets/thumbnails/poncho.jpg'

import thumb_pl from '@assets/thumbnails/kb_pl.jpg'
import thumb_en from '@assets/thumbnails/kb_en.jpg'
import thumb_fr from '@assets/thumbnails/kb_fr.jpg'
import thumb_de from '@assets/thumbnails/kb_de.jpg'

export const ProductThumbnailsHelper: { [key: string]: string } = {
  'avionaut-aerofix': Aerofix,
  'avionaut-aerofix-2-0': Aerofix2,
  'avionaut-aerofix-rwf': AerofixRWF,
  'avionaut-aerofix-rwf-2-0': AerofixRWF2,
  'avionaut-isofix-iq': Iq,
  'avionaut-maxspace-comfort-system': MaxSpaceCS,
  'avionaut-cosmo': Cosmo,
  'avionaut-pixel-pro': PixelPro,
  'avionaut-maxspace': MaxSpace,
  'avionaut-sky': Sky,
  'avionaut-sky-2-0': Sky2,
  'avionaut-pixel': Pixel,
  'avionaut-kite': Kite,
  'avionaut-dock': Dock,
  'avionaut-mata-na-okno': Mata,
  'avionaut-back-seat-baby-mirror': Mirror,
  'avionaut-organizer': Organiser,
  'avionaut-wkladka-antypotowa': Insert,
  'avionaut-spiworek': SleepBag,
  'avionaut-ponczo': Ponczo
}

export const ThumbnailsHelper : { [key: string]: string} = {
  'pl': thumb_pl,
  'en': thumb_en,
  'fr': thumb_fr,
  'de': thumb_de,
}
